<template>
  <v-card flat style="background-color:#e9e9e9;">
   
    <v-tabs  fixed-tabs elevation-0  style="background-color:#e9e9e9;">
      <v-tab @change="changetab('Media Category Master')">
        <v-icon left>
          mdi-bank
        </v-icon>
        Media Category Master
      </v-tab>

 <v-tab @change="changetab('Event + Category - Mapping')">
        <v-icon left>
          mdi-account-network
        </v-icon>
       Event + Category Mapping
      </v-tab>



 <v-tab @change="changetab('Sub Category Master')">
        <v-icon left>
          mdi-account-network
        </v-icon>
      Sub Category Master
      </v-tab>


       <v-tab @change="changetab('Category + Sub Category - Mapping')">
        <v-icon left>
          mdi-account-network
        </v-icon>
       Category + Sub Category Mapping
      </v-tab>


      <v-tab-item >
        <mediacategorymst></mediacategorymst>
      </v-tab-item>
     
     
       <v-tab-item style="background-color:#e9e9e9;">
       <EventMediaCategorymerge></EventMediaCategorymerge>
      </v-tab-item>
    

  <v-tab-item >
        <MediaSubcategoryMst></MediaSubcategoryMst>
      </v-tab-item>

       <v-tab-item >
        <MediaSubcatCategoryMap></MediaSubcatCategoryMap>
      </v-tab-item>
      
    </v-tabs>
  </v-card>
</template>
<script>
import mediacategorymst from '../../../components/MediaCategorymst'
import EventMediaCategorymerge from '../../../components/EventMediaCategorymerge.vue'
import MediaSubcategoryMst from '../../../components/MediaSubcategoryMst.vue'
import MediaSubcatCategoryMap from '../masters/MediaSubcatCategoryMap.vue'

export default {
 components: {mediacategorymst,EventMediaCategorymerge,MediaSubcategoryMst,MediaSubcatCategoryMap},
  methods:{
    changetab: function(pagename) {
        this.$store.commit("setPageTitle", pagename);
    }
 }
  
}
</script>